export const hasRole = (groups, roleKey) =>
  (groups || []).some(g => g && g.toLowerCase().includes(roleKey.toLowerCase()));

export const isRuleEngineAdmin = (groups) => hasRole(groups, 'insurancerule_admin');
export const isRuleEngineCCUser = (groups) => hasRole(groups, 'insurance-ruleengine-ccuser');
